module.exports = __webpack_public_path__ + "img/p2-77.74d619e6.png";